var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { makeStateKey } from '@angular/platform-browser';
export var NGRX_STATE = makeStateKey('NGRX_STATE');
export function stateTransferReducerFactory(transferState, platformId) {
    // if on the server, register the transferState.onSerialize listener & pass
    // in the last state on serialization
    var saveState;
    if (isPlatformServer(platformId)) {
        transferState.onSerialize(NGRX_STATE, function () { return saveState; });
    }
    return function (reducer) { return function (state, action) {
        var nextState = state;
        // if on the client & a state has been stored, load it
        var hasState = transferState.hasKey(NGRX_STATE);
        if (isPlatformBrowser(platformId) && hasState) {
            var transferedState = transferState.get(NGRX_STATE, null);
            transferState.remove(NGRX_STATE);
            nextState = __assign(__assign({}, state), transferedState);
        }
        saveState = reducer(nextState, action);
        return saveState;
    }; };
}
